var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visivel
    ? _c(
        "button",
        {
          staticClass: "composer-atencao ia-texto-corpo",
          attrs: { type: "button", title: _vm.rotulo },
          on: { click: _vm.aoClicar }
        },
        [
          _c("span", {
            staticClass: "composer-atencao__bolinha",
            style: { background: _vm.corDaBolinha }
          }),
          _c("span", { staticClass: "composer-atencao__rotulo" }, [
            _vm._v(_vm._s(_vm.rotulo))
          ]),
          _c("icon-svg", {
            staticClass: "composer-atencao__seta",
            attrs: {
              name: "arrow-left",
              size: _vm.TAMANHO_SETA,
              color: "var(--neutral-700)"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }